import React from 'react'
import TrainingDataStep from '../../components/Projects/Steps/TrainingDataStep'

const TrainingDataStepPage = () => {
  return (
    <div>
      <TrainingDataStep />
    </div>
  )
}

export default TrainingDataStepPage